import { useState, type FC } from "react";

import { Label } from "@/shared/components/ui/label";
import { CustomMultiSelect } from "@/shared/components/CustomMultiSelect";
import { ADDITIONAL_DETAIL_OPTIONS } from "@/shared/constants/contactDetailOptions";

import type { PersonContact } from "@/shared/types/estateContact";
import { EditSectionShell } from "./EditSectionShell";

const OPTIONS = ADDITIONAL_DETAIL_OPTIONS.map((o) => ({ value: o.value, label: o.label }));

interface AdditionalDetailsEditProps {
  contact: PersonContact;
  onCancel: () => void;
  onSave: (updates: Record<string, unknown>) => Promise<void>;
  isSaving: boolean;
}

export const AdditionalDetailsEdit: FC<AdditionalDetailsEditProps> = ({
  contact,
  onCancel,
  onSave,
  isSaving,
}) => {
  const [details, setDetails] = useState<Array<{ value: string; label: string }>>(
    (contact.additional_details || []).map((d) => {
      const opt = OPTIONS.find((o) => o.value === d);
      return opt || { value: d, label: d };
    }),
  );

  const handleSave = () => {
    onSave({
      additional_details: details.length > 0 ? details.map((d) => d.value) : null,
    });
  };

  return (
    <EditSectionShell
      title="Additional details"
      onCancel={onCancel}
      onSave={handleSave}
      isSaving={isSaving}
    >
      <div className="flex flex-col gap-1.5">
        <Label>Additional details</Label>
        <CustomMultiSelect
          options={OPTIONS}
          selected={details}
          onChange={setDetails}
          placeholder="Select all that apply"
        />
      </div>
    </EditSectionShell>
  );
};
